const translationMap = new Map<string, string>([
  ["cchp_ai_chat_agent_left_message", "Agent disconnected"],
  ["cchp_ai_chat_agent_transfer_join_message", "Agent connected"],
  ["cchp_ai_chat_agent_transfer_queue_next_message", "You are next in line"],
  [
    "cchp_ai_chat_agent_transfer_queue_size_message",
    "Queue Size: {QUEUE_SIZE}",
  ],
  ["cchp_ai_chat_agent_transfer_waiting_message", "Waiting for agent…"],
  [
    "cchp_ai_chat_disclosure",
    "Chat sessions are recorded by Topshop and our service providers. By using this chat, you agree to our [Terms and Service](https://www.topshop.com/gb/terms-and-conditions) and [Privacy Policy](https://www.topshop.com/gb/content/privacy-policy).",
  ],
  ["cchp_ai_chat_end_chat_button", "End chat"],
  ["cchp_ai_chat_end_message", "Chat Ended"],
  [
    "cchp_ai_chat_error_message",
    "Oops, an error was encountered! Please try again.",
  ],
  [
    "cchp_ai_chat_greeting_message",
    "Hi %{firstname} 😊. I'm your Topshop AI Assistant. I'm here to answer your Customer Care questions.\n\nHow can I help you today?",
  ],
  ["cchp_ai_chat_header", "Customer Care"],
  ["cchp_ai_chat_message_placeholder", "Message"],
  ["cchp_ai_chat_name", "Topshop Customer Care"],
  ["cchp_ai_chat_need_help", "Need help?"],
  ["cchp_ai_chat_print_transcript_button", "Print transcript"],
  ["cchp_ai_chat_save_transcript_button", "Save transcript"],
  ["cchp_ai_chat_start_chat_button", "Start Chat"],
  ["cchp_ai_chat_start_new_chat", "Start new chat"],
  ["cchp_ai_chat_transcript", "Transcript"],
]);

export const getTranslations = (key: string): string => {
  return translationMap.get(key) ?? key;
};
